import { render, staticRenderFns } from "./LinkItems.vue?vue&type=template&id=2d64c25c"
import script from "./LinkItems.vue?vue&type=script&lang=js"
export * from "./LinkItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports